module.exports = __webpack_public_path__ + "img/new-post-facebook-footer.0ce11bdc.jpg";